/**
 * משך Slide/רוחב אחיד למגירות dual-sidebar ולמגירות Bot Builder — כניסה/יציאה רכה בלי האטת 400ms.
 */
export const SIDEBAR_DRAWER_TRANSITION_MS = {
  enter: 280,
  exit: 220,
} as const;
